import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form } from 'common/components';
import { createRoute } from 'lib/util';

class AssetsActionDetail extends PureComponent {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    assetId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <Form.Link
      className="btn btn-sm btn-outline-info w-100 my-1"
      to={createRoute(
        this.props.companyId,
        this.props.subcompanyId,
        `assets/${this.props.assetId}/detail`
      )}
    >
      {this.props.t('actions.detail')}
    </Form.Link>
  );
}

export default translate()(AssetsActionDetail);



// WEBPACK FOOTER //
// src/components/assets/actions/AssetsActionsDetail.js